export const BRAND_BLUE = '#1ad3fd'